(function(){
  var gallery = document.querySelector('.gallery');
  var mainImg = document.getElementById('mainImg');
  var track = document.querySelector('[data-gallery-track]');
  var slides = Array.prototype.slice.call(document.querySelectorAll('[data-gallery-slide]'));
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbs button'));
  var current = document.querySelector('[data-gallery-current]');
  var mobileQuery = window.matchMedia('(max-width: 560px)');
  var scrollFrame;

  if (!gallery || !mainImg || !track || !slides.length) return;

  function setActive(index, shouldScroll){
    var safeIndex = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach(function(slide, slideIndex){
      slide.classList.toggle('is-active', slideIndex === safeIndex);
    });
    thumbs.forEach(function(thumb, thumbIndex){
      thumb.classList.toggle('active', thumbIndex === safeIndex);
      thumb.setAttribute('aria-current', thumbIndex === safeIndex ? 'true' : 'false');
    });
    if (current) current.textContent = String(safeIndex + 1);

    if (shouldScroll && mobileQuery.matches) {
      track.scrollTo({ left: slides[safeIndex].offsetLeft - 14, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function(thumb){
    thumb.addEventListener('click', function(){
      setActive(parseInt(thumb.dataset.galleryIndex, 10) || 0, true);
    });
  });

  track.addEventListener('scroll', function(){
    if (!mobileQuery.matches || scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(function(){
      var railCenter = track.scrollLeft + (track.clientWidth / 2);
      var nearestIndex = 0;
      var nearestDistance = Infinity;
      slides.forEach(function(slide, index){
        var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
        var distance = Math.abs(slideCenter - railCenter);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      setActive(nearestIndex, false);
      scrollFrame = null;
    });
  }, { passive: true });

  gallery.addEventListener('gallery:reset', function(){ setActive(0, true); });
  setActive(0, false);
})();

(function(){
  var form = document.querySelector('[data-product-form]');
  var variantsJson = document.querySelector('[data-product-variants]');
  var variantPricesJson = document.querySelector('[data-variant-prices]');
  var variantComparePricesJson = document.querySelector('[data-variant-compare-prices]');
  var variantSavingsJson = document.querySelector('[data-variant-savings]');
  if (!form || !variantsJson) return;

  var variants;
  var variantPrices = {};
  var variantComparePrices = {};
  var variantSavings = {};
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (error) {
    return;
  }
  if (variantPricesJson) {
    try {
      variantPrices = JSON.parse(variantPricesJson.textContent);
    } catch (error) {
      variantPrices = {};
    }
  }
  if (variantComparePricesJson) {
    try {
      variantComparePrices = JSON.parse(variantComparePricesJson.textContent);
    } catch (error) {
      variantComparePrices = {};
    }
  }
  if (variantSavingsJson) {
    try {
      variantSavings = JSON.parse(variantSavingsJson.textContent);
    } catch (error) {
      variantSavings = {};
    }
  }

  var optionInputs = Array.prototype.slice.call(form.querySelectorAll('[data-option-input]'));
  var variantIdInput = form.querySelector('[data-variant-id]');
  var addButton = form.querySelector('[data-add-button]');
  var addButtonLabel = form.querySelector('[data-add-button-label]');
  var variantError = form.querySelector('[data-variant-error]');
  var priceEls = document.querySelectorAll('[data-product-price], [data-sticky-price]');
  var comparePriceEls = document.querySelectorAll('[data-product-compare-price]');
  var savingsEls = document.querySelectorAll('[data-product-savings]');

  function selectedOptions(){
    var values = [];
    optionInputs.forEach(function(input){
      if (input.checked) values[parseInt(input.dataset.optionIndex, 10)] = input.value;
    });
    return values;
  }

  function findVariant(values){
    return variants.find(function(variant){
      return values.length === variant.options.length && variant.options.every(function(value, index){
        return value === values[index];
      });
    });
  }

  function formatMoney(variant){
    return variantPrices[String(variant.id)] || ('$' + (variant.price / 100).toFixed(2));
  }

  function updateSelectedStyles(changedInput){
    form.querySelectorAll('[data-option-index]').forEach(function(fieldset){
      var checked = fieldset.querySelector('[data-option-input]:checked');
      var selectedValue = fieldset.querySelector('[data-selected-option-value]');
      if (selectedValue && checked) selectedValue.textContent = checked.dataset.optionLabel || checked.value;
      fieldset.querySelectorAll('label').forEach(function(label){
        var input = label.querySelector('[data-option-input]');
        label.classList.toggle('selected', Boolean(input && input.checked));
      });
    });

    if (changedInput) {
      var changedLabel = changedInput.closest('label[data-hero]');
      var mainImg = document.getElementById('mainImg');
      if (changedLabel && mainImg && changedLabel.dataset.hero) {
        mainImg.src = changedLabel.dataset.hero;
        mainImg.removeAttribute('srcset');
        var firstThumb = document.querySelector('.thumbs button');
        if (firstThumb) {
          firstThumb.dataset.img = changedLabel.dataset.hero;
          var thumbImg = firstThumb.querySelector('img');
          if (thumbImg) thumbImg.src = changedLabel.dataset.hero;
          document.querySelectorAll('.thumbs button').forEach(function(thumb){ thumb.classList.remove('active'); });
          firstThumb.classList.add('active');
        }
        var gallery = document.querySelector('.gallery');
        if (gallery) gallery.dispatchEvent(new CustomEvent('gallery:reset'));
      }
    }
  }

  function updateVariant(changedInput){
    var variant = findVariant(selectedOptions());
    var canBuy = Boolean(variant && variant.available);

    if (variantIdInput) variantIdInput.value = variant ? variant.id : '';
    if (addButton) addButton.disabled = !canBuy;
    if (addButtonLabel) addButtonLabel.textContent = canBuy ? 'Add set to cart' : 'Sold out';
    if (variantError) variantError.hidden = Boolean(variant);

    if (variant) {
      var price = formatMoney(variant);
      var comparePrice = Number(variant.compare_at_price || 0);
      var onSale = comparePrice > variant.price;
      priceEls.forEach(function(el){ el.textContent = price; });
      comparePriceEls.forEach(function(el){
        el.hidden = !onSale;
        el.textContent = onSale ? (variantComparePrices[String(variant.id)] || ('$' + (comparePrice / 100).toFixed(2))) : '';
      });
      savingsEls.forEach(function(el){
        var savingsAmount = comparePrice - variant.price;
        var savingsPercent = onSale ? Math.round((savingsAmount / comparePrice) * 100) : 0;
        var formattedSavings = variantSavings[String(variant.id)] || ('$' + (savingsAmount / 100).toFixed(2));
        el.hidden = !onSale;
        el.textContent = onSale
          ? (el.dataset.savingsFormat === 'percent-only'
            ? ('SAVE ' + savingsPercent + '%')
            : ('Save ' + formattedSavings + ' \u2022 ' + savingsPercent + '% off'))
          : '';
      });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    updateSelectedStyles(changedInput);
  }

  optionInputs.forEach(function(input){
    input.addEventListener('change', function(){ updateVariant(input); });
  });

  var initialColorInput = form.querySelector('label[data-hero] [data-option-input]:checked');
  updateVariant(initialColorInput || undefined);
})();

(function(){
  document.querySelectorAll('.qty-stepper').forEach(function(stepper){
    var input = stepper.querySelector('.qty-input');
    var minus = stepper.querySelector('.qty-minus');
    var plus = stepper.querySelector('.qty-plus');
    function clamp(){
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      input.value = val;
    }
    minus.addEventListener('click', function(){
      clamp();
      input.value = parseInt(input.value, 10) - 1;
      clamp();
    });
    plus.addEventListener('click', function(){
      clamp();
      input.value = parseInt(input.value, 10) + 1;
    });
    input.addEventListener('change', clamp);
  });
})();

(function(){
  var stickybar = document.querySelector('.stickybar');
  var buyButton = document.querySelector('[data-add-button]');
  if (!stickybar || !buyButton || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries){
    stickybar.classList.toggle('is-hidden', entries[0].isIntersecting);
  }, { threshold: 0.35 });

  observer.observe(buyButton);
})();

(function(){
  document.querySelectorAll('form').forEach(function(form){
    var btn = form.querySelector('button[name="add"]');
    if (!btn) return;
    form.addEventListener('submit', function(e){
      if (form.dataset.submitting === 'true') {
        e.preventDefault();
        return;
      }
      form.dataset.submitting = 'true';
      btn.disabled = true;
    });
  });
})();

(function(){
  var dialog = document.querySelector('[data-size-guide-dialog]');
  var triggers = document.querySelectorAll('[data-size-guide-open]');
  var closeButton = dialog && dialog.querySelector('[data-size-guide-close]');
  var activeTrigger = null;
  if (!dialog || !triggers.length) return;

  function openGuide(trigger){
    activeTrigger = trigger;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function closeGuide(){
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  triggers.forEach(function(trigger){
    trigger.addEventListener('click', function(){ openGuide(trigger); });
  });
  if (closeButton) closeButton.addEventListener('click', closeGuide);
  dialog.addEventListener('click', function(event){
    if (event.target === dialog) closeGuide();
  });
  dialog.addEventListener('close', function(){
    if (activeTrigger) activeTrigger.focus();
  });
})();

(function(){
  var dialog = document.querySelector('[data-review-lightbox]');
  var image = dialog && dialog.querySelector('[data-review-lightbox-image]');
  var closeButton = dialog && dialog.querySelector('[data-review-lightbox-close]');
  var triggers = document.querySelectorAll('[data-review-image-open]');
  var activeTrigger = null;
  if (!dialog || !image || !triggers.length) return;

  function openPhoto(trigger){
    activeTrigger = trigger;
    image.src = trigger.getAttribute('data-review-image-src') || '';
    image.alt = trigger.getAttribute('data-review-image-alt') || 'Customer review photo';
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function resetPhoto(){
    image.removeAttribute('src');
    image.alt = '';
    if (activeTrigger) activeTrigger.focus();
  }

  function closePhoto(){
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      resetPhoto();
    }
  }

  triggers.forEach(function(trigger){
    trigger.addEventListener('click', function(){ openPhoto(trigger); });
  });
  if (closeButton) closeButton.addEventListener('click', closePhoto);
  dialog.addEventListener('click', function(event){
    if (event.target === dialog) closePhoto();
  });
  dialog.addEventListener('close', resetPhoto);
})();
